// Friendly, human labels + colors for raw part statuses (no developer shorthand).
export const STATUS_LABEL = {
  on_donor: "On Donor",
  staging_needs_id: "Needs ID",
  staging_needs_grade: "Needs Grade",
  staging_needs_price: "Needs Price",
  available: "Available",
  reserved: "Reserved",
  picked: "Picked",
  in_transit: "In Transit",
  installed: "Installed",
  sold: "Sold",
  returned_pending_inspection: "Return — Inspect",
  returned_to_stock: "Back in Stock",
  defective: "Defective",
  core: "Core",
  scrap: "Scrap",
  recycled: "Recycled",
  archived: "Archived",
};

export const STATUS_COLOR = {
  available: "bg-emerald-600",
  on_donor: "bg-zinc-500",
  staging_needs_id: "bg-amber-500",
  staging_needs_grade: "bg-amber-500",
  staging_needs_price: "bg-amber-500",
  core: "bg-purple-600",
  in_transit: "bg-indigo-600",
  defective: "bg-red-600",
  scrap: "bg-red-700",
  recycled: "bg-zinc-500",
  archived: "bg-zinc-400",
};

// A part is "consumed" (history, not active stock) once it's archived or in a terminal
// outbound/write-off state. Used to DIM it on the donor truck view (still shown, just greyed).
export const CONSUMED_STATUSES = ["sold", "installed", "scrap", "defective", "core", "recycled", "archived", "removed"];
export const isConsumedPart = (p) => !!(p && (p.archived || CONSUMED_STATUSES.includes(p.status)));

export const statusLabel = (s) => STATUS_LABEL[s] || (s || "").replace(/_/g, " ");
export const statusColor = (s) => STATUS_COLOR[s] || "bg-zinc-500";

// A part reserved to a cart must NEVER read a plain "Available" — it's locked to a cart/PO and
// could otherwise look pickable/sellable again. These take the whole part and surface the reserved
// truth (PO/job) instead of the raw status. Use these for any part badge in a list/detail.
export const partReservedTag = (p) =>
  p && p.reserved_cart_id ? (p.reserved_label || p.reserved_po || p.reserved_cart_number || "a cart") : null;
export const partStatusLabel = (p) => {
  const r = partReservedTag(p);
  return r ? `On cart · ${r}` : statusLabel(p?.status);
};
export const partStatusColor = (p) => (partReservedTag(p) ? "bg-blue-600" : statusColor(p?.status));

export const DONOR_STATUS_LABEL = {
  // legacy (pre-revamp) — kept so historical rows still read cleanly
  awaiting: "Awaiting", whole: "Whole", fully_dismantled: "Fully Dismantled",
  // current editable pipeline (seed labels; the managed list is the source of truth)
  purchased: "Purchased", in_transit: "In Transit", arrived: "Arrived", checked_in: "Checked In",
  dismantling: "Dismantling", partially_dismantled: "Partly Dismantled",
  frame_components: "Frame Rails & Components", scrapped: "Scrapped", archived: "Archived",
};
export const donorStatusLabel = (s) => DONOR_STATUS_LABEL[s] || (s || "").replace(/_/g, " ");
